export class BoolUtility {
  static hasValue = (val: boolean | undefined | null) =>
    val !== null && val !== undefined;
}
